import React from 'react';
import ReactDOM from 'react-dom/client';
import {configure} from 'mobx';
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {BrowserRouter, Route, Routes} from "react-router";
import {AppRoutes} from "./AppRoutes";
import {LoginPage} from "./pages/LoginPage";
import {HomePage} from "./pages/HomePage";
import useInstance from "./hooks/useInstance";
import {AuthContext} from "./stores/AuthStore";
import Theme from "./Theme";
import {ToastContainer} from 'react-toastify';
import {AppContext, AppStore} from "./stores/AppStore";
import {ApiContext} from "./api/api";
import {ProtectedRoute} from "./components/routing/ProtectedRoute";
import {MySessions} from "./pages/MySessions";
import {OrganizationSessions} from "./pages/OrganizationSessions";
import {Lessons} from "./pages/Lessons";
import {RecordingPage} from "./pages/RecordingPage";
import {LessonPage} from "./pages/LessonPage";
import {LessonEditorPage} from "./pages/LessonEditorPage";
import {HomeLayout} from "./pages/HomeLayout";
import {ConfirmationDialog} from "./components/common/ConfirmationDialog";

configure({enforceActions: 'never'});

if (!Object.prototype.hasOwnProperty.call(new class {
  x: any;
}(), 'x')) throw new Error('Transpiler is not configured correctly');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const App = () => {
  const app = useInstance(() => new AppStore());
  if (!app) return null;
  return <AuthContext.Provider value={app.auth}>
    <ApiContext value={app.api}>
      <AppContext value={app}>
        <Theme>
          <BrowserRouter>
            <Routes>
              <Route path={AppRoutes.index} element={<ProtectedRoute><HomeLayout/></ProtectedRoute>}>
                <Route index element={<HomePage/>}/>
                <Route path={AppRoutes.mySessions} element={<MySessions/>}/>
                <Route
                  path={AppRoutes.organizationSessions}
                  element={<OrganizationSessions/>}
                />
                <Route path={AppRoutes.mySession} element={<RecordingPage scope="my"/>}/>
                <Route path={AppRoutes.organizationSession} element={<RecordingPage scope="organization"/>}/>
                <Route path={AppRoutes.lessons} element={<ProtectedRoute><Lessons/></ProtectedRoute>}/>
                <Route path={AppRoutes.lessonEditor} element={<LessonEditorPage/>}/>
                <Route path={AppRoutes.lesson} element={<LessonPage/>}/>
              </Route>
              <Route path={AppRoutes.login} element={<LoginPage/>}/>
            </Routes>
          </BrowserRouter>
          <ToastContainer position={'bottom-right'}/>
          <ConfirmationDialog/>
        </Theme>
      </AppContext>
    </ApiContext>
  </AuthContext.Provider>;
};

root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);
